
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as testWAmRdgC_JsMpRTj2Lw1hcgaT_45NU9xgELwBJuztcYPh8Meta } from "/app/pages/test.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as eventsnq25H_M5ElYPBbLSJVGOUR4t2bWHw5bjIBkdObjG85IMeta } from "/app/pages/events.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as welcomeZPrEddxWJc2ey1MEbIjgSlcrr_5_45tSo_42WYcPnDwp0Meta } from "/app/pages/welcome.vue?macro=true";
import { default as add_45gamec_6_9GiBpgQJvo109jUseyID7xE1Aa2e354Nce6O2EgMeta } from "/app/pages/add-game.vue?macro=true";
import { default as edit_45gamesLQBKXyvwG5Ikl_825XiptBDa_TsBeFEXgOiQYJme5ioMeta } from "/app/pages/edit-games.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as indexHDFYOD2CBLzc5E17EJOgdRgtZvG1bjkwXjjB_KQpdDAMeta } from "/app/pages/forum/index.vue?macro=true";
import { default as maintenanceT_45jg7_pWb39JSa1hwfoRit1d5KL66Qjib5lqwfdmyV8Meta } from "/app/pages/maintenance.vue?macro=true";
import { default as create6sFEATQGp0pL55r3U1jsBcjdKTpVHerws0_45YPKOYQq4Meta } from "/app/pages/event/create.vue?macro=true";
import { default as search4EKSMhv9sPZ74IFpt0WCirWIbjl1pPWfYIAgNnF_45hQcMeta } from "/app/pages/forum/search.vue?macro=true";
import { default as editorf3jxF_GGDnUKe_Ph5ZkerL9ichus8OQyCcpHVjm096YMeta } from "/app/pages/charts/editor.vue?macro=true";
import { default as indexS5j0VXiRvW66ZE0xq5nMmdOaOliQE17LOPXTOMExGOsMeta } from "/app/pages/friends/index.vue?macro=true";
import { default as editF1YfYEvjkK5ohj_Hmk4KgfYdekCKlNf1uz8kUMWuBEAMeta } from "/app/pages/game/[id]/edit.vue?macro=true";
import { default as reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as _91name_93dytFIBIyQ9fPuYV49SDzpHt_deGlV1pA8KdMRdC_45vrEMeta } from "/app/pages/scripts/[name].vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as perksH2O1j7SIiPhq9hSnd3s5kLBCBOWAadzQ8pemwzUrU5IMeta } from "/app/pages/settings/perks.vue?macro=true";
import { default as user_45datal7mN3tqD_2fst2mi7oLhco1b8_YAswujw7wCFIRbMzUMeta } from "/app/pages/admin/user-data.vue?macro=true";
import { default as indexGIg01HMusGl57fmD8a_45DzoPygQJf9hzozswEsm_45uON8Meta } from "/app/pages/community/index.vue?macro=true";
import { default as indexjYX8SXZgyOpApJ5_E_45bVI0QbPkLAEv3cMuheh8HOXpcMeta } from "/app/pages/game/[id]/index.vue?macro=true";
import { default as _91role_id_93sd1F0Q8FGDLNIwiY3lZowizLzN6W7a6PzJPX7Z2r90gMeta } from "/app/pages/roles/[role_id].vue?macro=true";
import { default as banskcaC9okOaRWqlYbQw09kKNaRceea4GMtnhXkrLVaqEIMeta } from "/app/pages/admin/forum/bans.vue?macro=true";
import { default as createybMNE3Njb4X48dprTbFjR_45vEyzB0DoXGWwaX3vHZaA0Meta } from "/app/pages/community/create.vue?macro=true";
import { default as newn8mUZjYcOhb0nmDifjiKAW9olAJ2rLU54goZbF7z6FYMeta } from "/app/pages/forum/[slug]/new.vue?macro=true";
import { default as subscribedwY2Ik54t_e0HqxsJ0UcSCMjmH6Iu8yqPdvx_65kJ6k4Meta } from "/app/pages/forum/subscribed.vue?macro=true";
import { default as requestsySZ0EcS1e7o5AfHTmJoAnsYLjdrMviM9SDgUx9EcyFsMeta } from "/app/pages/friends/requests.vue?macro=true";
import { default as accountYaW2Hju_BYde55CgkuaY5YUTw34fttXrs6fR3vDa4fsMeta } from "/app/pages/settings/account.vue?macro=true";
import { default as indexjdq5u0uoYiudGy6u6ZgjA19pIJfAv8nF9n9Ey3wzYxYMeta } from "/app/pages/@[username]/index.vue?macro=true";
import { default as preferencesODUAsMN_45gxea_56M13m40sX5x82RVS_yFAmNQV4s6kMMeta } from "/app/pages/forum/preferences.vue?macro=true";
import { default as submissionsA8qRZ79sSbPhU3nN7DtfRAWvYe8wwZsby4q6KmPF5eYMeta } from "/app/pages/forum/submissions.vue?macro=true";
import { default as suggestedCF7bJ7oP3btF36CKRhuQAl9PL0eCMD_45EwjB2X74FlqsMeta } from "/app/pages/friends/suggested.vue?macro=true";
import { default as passwordNVWE3EfleOq6pk0GfC9PP9zdqd_45L25z7QS8QgKB7ToYMeta } from "/app/pages/settings/password.vue?macro=true";
import { default as groupsVnkILhT7gplToEvybnoxFWglF_45TMIH9HBW2uDlg_45F4oMeta } from "/app/pages/admin/forum/groups.vue?macro=true";
import { default as indexmUcQix93PQoEUJb8uYicVdGDH8y0ikosI9KaQWZDQ9IMeta } from "/app/pages/forum/[slug]/index.vue?macro=true";
import { default as feature_45flagsCdhmh5ZysQdbENeYNdnY2RUh0uWBgPWZ5A77PHDnGvEMeta } from "/app/pages/admin/feature-flags.vue?macro=true";
import { default as mod_45logkfS7KPAXoEgPoTxv4rF2_qtqtA0Y0zhkk3Rub_45cUDfwMeta } from "/app/pages/admin/forum/mod-log.vue?macro=true";
import { default as reportsYoVmwLJUnKk_F5YuyR0TdzS2AFD_45TXBTYytcZND4UJ0Meta } from "/app/pages/admin/forum/reports.vue?macro=true";
import { default as circular_45games6ql09ZTAgZalGI_A7ML3m_45YkYZ5jFyHzdXjUWC5sPMYMeta } from "/app/pages/admin/circular-games.vue?macro=true";
import { default as _91event_short_code_932QNZoAdxMHuxqRLwhA5ANSMfR3vYTzYpZ6WGJMgK_dIMeta } from "/app/pages/e/[event_short_code].vue?macro=true";
import { default as editU7YHUczM5I87Hzkb1p6qLNHEH8vQdW4dtUMyGr2GT5YMeta } from "/app/pages/event/[eventId]/edit.vue?macro=true";
import { default as indexvtGFqeojvJRY2Hnbd2dXuYZLJNt8R10vRJJ3cgvXzEAMeta } from "/app/pages/year-in-review/index.vue?macro=true";
import { default as indexftxsovKoRL2mFOGCq2MVAK40wbx9rINXRxOgVkn9eBwMeta } from "/app/pages/event/[eventId]/index.vue?macro=true";
import { default as integrationsjFDcq9QFs5QLPqDDI_czw2JQIy530SKqtqHiTIOv3m0Meta } from "/app/pages/settings/integrations.vue?macro=true";
import { default as categoriesykjI8KPYP1h5I6hZwyM5_45BEGg9ZkirgZOHCE1g3ZyPEMeta } from "/app/pages/admin/forum/categories.vue?macro=true";
import { default as moderationNaBLLSVy72zKclxr_45vbocLtiEU_45eAxIUHSIbALbt_1EMeta } from "/app/pages/admin/forum/moderation.vue?macro=true";
import { default as gamesdUrsYDrk51cOH26aZFpzyBVtMfKrO8DMTxEkZiCNZGwMeta } from "/app/pages/community/[slug]/games.vue?macro=true";
import { default as indexucBkkte_45BgbICRhgFL4C3nMmpyYEWHl2kuK_45AGIXyaEMeta } from "/app/pages/community/[slug]/index.vue?macro=true";
import { default as statshG25v6JCc3bkZSSICYhjMsdRIEeagH8pv37AMs121HUMeta } from "/app/pages/community/[slug]/stats.vue?macro=true";
import { default as notificationsWUt0TcF6oSDlzx1RBvKu1fSjfw4nNGgmtf5XWcyGTR4Meta } from "/app/pages/settings/notifications.vue?macro=true";
import { default as dashboardLZ1fTMrQu8KYwa5MJrSr_45Rc9EvFGFpY8oCSQ6q7tHk8Meta } from "/app/pages/community/[slug]/dashboard.vue?macro=true";
import { default as _91id_93CgwdV4CXQt1cLM8xZy3NcUykHe_453Ac90KAIcjftdeSYMeta } from "/app/pages/year-in-review/[year]/[id].vue?macro=true";
import { default as indexs59_45zGU_Gg8EK9OZdfgxvgBkkcNSFtmMcMfm2bjpmAIMeta } from "/app/pages/@[username]/game/[id]/index.vue?macro=true";
import { default as indexpAO3Aqfu3k0kkEmhrLUVdCuHrRKGiwz72SvTSddx7KEMeta } from "/app/pages/community/[slug]/events/index.vue?macro=true";
import { default as index0WgnxNzR6OlOTKzD39JO3KRxD9NG3Jbz6clseiYDX2AMeta } from "/app/pages/forum/[slug]/[threadId]/index.vue?macro=true";
import { default as _91eventId_93azssJ4VRk0CH_458l9dGf_yUa8WEKB9Fn5b6Dy8AKXhYgMeta } from "/app/pages/community/[slug]/event/[eventId].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"guest"},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/app/pages/events.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/welcome.vue")
  },
  {
    name: "add-game",
    path: "/add-game",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/add-game.vue")
  },
  {
    name: "edit-games",
    path: "/edit-games",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/edit-games.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "forum",
    path: "/forum",
    component: () => import("/app/pages/forum/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/app/pages/maintenance.vue")
  },
  {
    name: "event-create",
    path: "/event/create",
    meta: {"middleware":"community-admin"},
    component: () => import("/app/pages/event/create.vue")
  },
  {
    name: "forum-search",
    path: "/forum/search",
    component: () => import("/app/pages/forum/search.vue")
  },
  {
    name: "charts-editor",
    path: "/charts/editor",
    component: () => import("/app/pages/charts/editor.vue")
  },
  {
    name: "friends",
    path: "/friends",
    component: () => import("/app/pages/friends/index.vue")
  },
  {
    name: "game-id-edit",
    path: "/game/:id()/edit",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/game/[id]/edit.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "scripts-name",
    path: "/scripts/:name()",
    component: () => import("/app/pages/scripts/[name].vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "settings-perks",
    path: "/settings/perks",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/perks.vue")
  },
  {
    name: "admin-user-data",
    path: "/admin/user-data",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/user-data.vue")
  },
  {
    name: "community",
    path: "/community",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/community/index.vue")
  },
  {
    name: "game-id",
    path: "/game/:id()",
    component: () => import("/app/pages/game/[id]/index.vue")
  },
  {
    name: "roles-role_id",
    path: "/roles/:role_id()",
    component: () => import("/app/pages/roles/[role_id].vue")
  },
  {
    name: "admin-forum-bans",
    path: "/admin/forum/bans",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/bans.vue")
  },
  {
    name: "community-create",
    path: "/community/create",
    component: () => import("/app/pages/community/create.vue")
  },
  {
    name: "forum-slug-new",
    path: "/forum/:slug()/new",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/forum/[slug]/new.vue")
  },
  {
    name: "forum-subscribed",
    path: "/forum/subscribed",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/forum/subscribed.vue")
  },
  {
    name: "friends-requests",
    path: "/friends/requests",
    component: () => import("/app/pages/friends/requests.vue")
  },
  {
    name: "settings-account",
    path: "/settings/account",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/account.vue")
  },
  {
    name: "@username",
    path: "/@:username()",
    component: () => import("/app/pages/@[username]/index.vue")
  },
  {
    name: "forum-preferences",
    path: "/forum/preferences",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/forum/preferences.vue")
  },
  {
    name: "forum-submissions",
    path: "/forum/submissions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/forum/submissions.vue")
  },
  {
    name: "friends-suggested",
    path: "/friends/suggested",
    component: () => import("/app/pages/friends/suggested.vue")
  },
  {
    name: "settings-password",
    path: "/settings/password",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/password.vue")
  },
  {
    name: "admin-forum-groups",
    path: "/admin/forum/groups",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/groups.vue")
  },
  {
    name: "forum-slug",
    path: "/forum/:slug()",
    component: () => import("/app/pages/forum/[slug]/index.vue")
  },
  {
    name: "admin-feature-flags",
    path: "/admin/feature-flags",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/feature-flags.vue")
  },
  {
    name: "admin-forum-mod-log",
    path: "/admin/forum/mod-log",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/mod-log.vue")
  },
  {
    name: "admin-forum-reports",
    path: "/admin/forum/reports",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/reports.vue")
  },
  {
    name: "admin-circular-games",
    path: "/admin/circular-games",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/circular-games.vue")
  },
  {
    name: "e-event_short_code",
    path: "/e/:event_short_code()",
    component: () => import("/app/pages/e/[event_short_code].vue")
  },
  {
    name: "event-eventId-edit",
    path: "/event/:eventId()/edit",
    meta: {"middleware":"community-admin"},
    component: () => import("/app/pages/event/[eventId]/edit.vue")
  },
  {
    name: "year-in-review",
    path: "/year-in-review",
    component: () => import("/app/pages/year-in-review/index.vue")
  },
  {
    name: "event-eventId",
    path: "/event/:eventId()",
    component: () => import("/app/pages/event/[eventId]/index.vue")
  },
  {
    name: "settings-integrations",
    path: "/settings/integrations",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/integrations.vue")
  },
  {
    name: "admin-forum-categories",
    path: "/admin/forum/categories",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/categories.vue")
  },
  {
    name: "admin-forum-moderation",
    path: "/admin/forum/moderation",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forum/moderation.vue")
  },
  {
    name: "community-slug-games",
    path: "/community/:slug()/games",
    component: () => import("/app/pages/community/[slug]/games.vue")
  },
  {
    name: "community-slug",
    path: "/community/:slug()",
    component: () => import("/app/pages/community/[slug]/index.vue")
  },
  {
    name: "community-slug-stats",
    path: "/community/:slug()/stats",
    component: () => import("/app/pages/community/[slug]/stats.vue")
  },
  {
    name: "settings-notifications",
    path: "/settings/notifications",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings/notifications.vue")
  },
  {
    name: "community-slug-dashboard",
    path: "/community/:slug()/dashboard",
    meta: {"middleware":"community-admin"},
    component: () => import("/app/pages/community/[slug]/dashboard.vue")
  },
  {
    name: "year-in-review-year-id",
    path: "/year-in-review/:year()/:id()",
    component: () => import("/app/pages/year-in-review/[year]/[id].vue")
  },
  {
    name: "@username-game-id",
    path: "/@:username()/game/:id()",
    component: () => import("/app/pages/@[username]/game/[id]/index.vue")
  },
  {
    name: "community-slug-events",
    path: "/community/:slug()/events",
    component: () => import("/app/pages/community/[slug]/events/index.vue")
  },
  {
    name: "forum-slug-threadId",
    path: "/forum/:slug()/:threadId()",
    component: () => import("/app/pages/forum/[slug]/[threadId]/index.vue")
  },
  {
    name: "community-slug-event-eventId",
    path: "/community/:slug()/event/:eventId()",
    component: () => import("/app/pages/community/[slug]/event/[eventId].vue")
  }
]